import React from 'react'
import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text-v1'

import PelaksanaanPraktikKinerjaAppealCard from 'app/KinerjaPenilikPegawaiPage/components/PelaksanaanPraktikKinerjaAppealCard'

const STEPS = [
  {
    key: 'DISKUSI_PERSIAPAN',
    title: 'Diskusi Persiapan',
    subtitle: 'Pengisian akan dihapus',
    imageSrc: '/illustrations/img-document-penci-fill.png',
  },
  {
    key: 'PENDAMPINGAN_SEKOLAH',
    title: 'Pendampingan Satuan Pendidikan',
    subtitle: 'Pengisian akan dihapus',
    imageSrc: '/illustrations/img-assessment-clipboard-school.png',
  },
  {
    key: 'DISKUSI_TINDAK_LANJUT',
    title: 'Rencana Tindak Lanjut',
    subtitle: 'Hasil pemantauan Tim Kinerja akan dihapus',
    imageSrc: '/illustrations/img-document-interaction-discussion.png',
  },
  {
    key: 'UPAYA_TINDAK_LANJUT',
    title: 'Upaya Tindak Lanjut',
    subtitle: 'Pengisian akan dihapus',
    imageSrc: '/illustrations/img-clip-board-summary.png',
  },
  {
    key: 'REFLEKSI_TINDAK_LANJUT',
    title: 'Refleksi dan Evaluasi Tindak Lanjut',
    subtitle: 'Pengisian dan hasil pemantauan Tim Kinerja akan dihapus',
    imageSrc: '/illustrations/img-disiplin-positif-stundet-board.png',
  },
]

type TDialogPelaksanaanAppealRequestProps = {
  formName: string
  currentState: string
  isOpen: boolean
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
}
export const DialogPelaksanaanAppealRequest: React.FC<
  TDialogPelaksanaanAppealRequestProps
> = ({ formName, currentState, isOpen, isLoading, onClose, onConfirm }) => {
  const [agree, setAgree] = React.useState<boolean>(false)

  const currentStateStep = React.useMemo(() => {
    if (currentState === 'DISKUSI_TINDAK_LANJUT_PENILAIAN') {
      return 3
    }
    if (
      ['REFLEKSI_TINDAK_LANJUT_PENILAIAN', 'SELESAI'].includes(currentState)
    ) {
      return 5
    }

    return STEPS.findIndex((step) => step.key === currentState)
  }, [currentState])
  const formStep = React.useMemo(
    () => STEPS.findIndex((step) => step.key === formName.toUpperCase()),
    [formName]
  )
  const displayedSteps = React.useMemo(
    () => STEPS.slice(formStep, currentStateStep),
    [currentStateStep, formStep]
  )

  React.useEffect(() => {
    return () => {
      setAgree(false)
    }
  }, [isOpen])

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      autoFocus={false}
      returnFocus={false}
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <NextImage
            src="/illustrations/img-folder-document-rejected.png"
            width={84}
            height={84}
          />

          <div className="space-y-4">
            <Text variant="heading-md">
              Ajukan perubahan ke Tim Kinerja. Berikut hal yang terdampak:
            </Text>

            {displayedSteps.map((step, index) => (
              <PelaksanaanPraktikKinerjaAppealCard key={index} {...step} />
            ))}
          </div>

          <Separator />

          <div className="pb-4">
            <Checkbox
              className="mt-2"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            >
              <Text variant="heading-sm">
                Saya setuju untuk mengulang pengisian
              </Text>
            </Checkbox>
          </div>

          <div className="flex justify-end space-x-5">
            <Button
              data-testid="appeal-request-back-button"
              disabled={isLoading}
              onClick={onClose}
              color="white"
              size="lg"
            >
              Kembali
            </Button>
            <Button
              className="flex items-center justify-center gap-x-2"
              onClick={onConfirm}
              color="blue"
              size="lg"
              disabled={!agree || isLoading}
              isLoading={isLoading}
            >
              <Icon color={agree ? 'inverse' : 'disabled'} fontSize="sm">
                lock_outline
              </Icon>
              Ajukan perubahan
            </Button>
          </div>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
